import * as React from 'react';
import { useTheme } from '../../../theme';
import cn from 'classnames';
import BaggageItem from './BaggageItem/BaggageItem';
import { BaggageItem as BaggageItemType } from '../types';
import { MOBILE_MIN_WIDTH } from '../../../utils';
import SlickSlider from '../../../SlickSlider';

interface Props {
	items: BaggageItemType[];
	className?: string;
	slidesToShow?: number;
}

const BaggageList: React.FC<Props> = ({ items, className, slidesToShow }) => {
	const { BaggageList: css } = useTheme('BaggageList');

	const slidesToShowCount = slidesToShow ?? 1;

	return (
		<SlickSlider
			slidesToShow={Math.min(slidesToShowCount, items.length)}
			arrows={true}
			infinite={false}
			variableWidth={false}
			dots={true}
			className={cn(css.root, className)}
			responsive={[
				{
					breakpoint: MOBILE_MIN_WIDTH,
					settings: {
						slidesToShow: 1
					}
				}
			]}
		>
			{items.map((item, i) => (
				<BaggageItem {...item} key={i} />
			))}
		</SlickSlider>
	);
};

export default BaggageList;
